import { render, staticRenderFns } from "./add_welcome_message.vue?vue&type=template&id=f69fa528&"
import script from "./add_welcome_message.vue?vue&type=script&lang=js&"
export * from "./add_welcome_message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports